import React, { lazy, Suspense, useState } from 'react';
import LayoutWrapper from './component/common-component/common-layout-wrapper/LayoutWrapper';
import CmnBackdrop from './component/common-component/common-backdrop/CmnBackdrop';
import { Routes, BrowserRouter, Route, Navigate } from 'react-router-dom';

const Login = lazy(() => import('./container/loginContainer/loginContainer'))
const LoginMfa = lazy(() => import('./container/LoginMfaContainer/LoginMfaContainer'));
const DashboardContainer = lazy(() => import('./container/DashboardContainer/DashboardContainer'));
const SystemContainer = lazy(() => import('./container/SystemContainer/SystemContainer'));
const SystemTemplatesContainer = lazy(() => import('./container/SystemTemplatesContainer/SystemTemplatesContainer'));
const UserAccountsContainer = lazy(() => import('./container/UserAccountsContainer/UserAccountsContainer'));
const Preference = lazy(() => import('./container/PreferenceContainer/preferenceContainer'))
const Reports = lazy(() => import('./container/ReportContainer/ReportContainer'))
const Workflow = lazy(() => import('./container/SystemWorkflowContainer/SystemWorkflowContainer'))


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(true);


  const handleLoginRoutes = () => {
    setIsAuthenticated(true);
  };

  const handleLogoutRoutes = () => {
    setIsAuthenticated(false);
  };
  const PrivateRoute = ({ children }) => {
    return sessionStorage.getItem('token')!=null ? children : <Navigate to="/" />;
  };

  return (
    <BrowserRouter>
      <LayoutWrapper handleRoutes={handleLogoutRoutes}>
        <Suspense fallback={<div><CmnBackdrop backdrop={true} /></div>}>
          <Routes>
            <Route path="/" element={<Login handleLoginRoutes={handleLoginRoutes} />} />
            <Route 
              path="/mfa" 
              element={
                <PrivateRoute>
                  <LoginMfa />
                </PrivateRoute>
              } 
            />
            <Route path='/dashboard' element={
              <PrivateRoute>
                <DashboardContainer />
              </PrivateRoute>
            } />
            <Route path='/system' element={
              <PrivateRoute>
                <SystemContainer />
              </PrivateRoute>
            } />
            <Route path='/user-accounts' element={
              <PrivateRoute>
                <UserAccountsContainer />
              </PrivateRoute>
            } />
            <Route path='/reports' element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            } />
            <Route path='/system-template' element={
              <PrivateRoute>
                <SystemTemplatesContainer />
              </PrivateRoute>
            } />
            <Route path='/preference' element={
              <PrivateRoute>
                <Preference />
              </PrivateRoute>
            } />
            <Route path='/workflow' element={
              <PrivateRoute>
                <Workflow />
              </PrivateRoute>
            } />
          </Routes>
        </Suspense>
      </LayoutWrapper>
    </BrowserRouter>
  );
}

export default App;
